<form [formGroup]="topUpInputForm">
    <div class="row">
        <div class="col-xs-6 col-md-3 col-lg-3">
            <label for="amount">Top Up Amount</label>
        </div>
        <div class="col-xs-6 col-md-8 col-lg-8">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <select (change)="broadcastNewAmount()" [value]="minimumTopUp" class="form-control" formControlName="amount">
                        <option [value]="minimumTopUp">£100</option>
                        <option value="250">£250</option>
                        <option value="500">£500</option>
                        <option value="custom">Custom</option>
                    </select>
                </div>
                <div class="col-xs-6 offset-xs-6 col-md-6 mt-1 mt-md-0" *ngIf="isCustomAmount">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">£</span>
                        </div>
                        <input type="text" (change)="broadcastNewAmount()"
                            placeholder="Enter Your Prefered Amount (minimum £{{minimumTopUp}})" 
                            required
                            class="form-control" 
                            formControlName="customAmount">
                    </div>
                    <r247-validation-message errorMessage="Please top up by at least £{{minimumTopUp}}" [showError]="customAmount?.errors?.min && customAmount?.touched"></r247-validation-message>
                    <r247-validation-message errorMessage="Please enter your top up amount" [showError]="(customAmount?.errors?.required && customAmount?.touched) || (topUpForm?.get('amount')?.errors?.required && topUpForm?.touched)"></r247-validation-message>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
                <div class="row">
                    <div class="col-xs-6 col-md-3 col-lg-3">
                        Your account will be credited with
                    </div>
                    <div class="col-xs-6 col-md-8 col-lg-8">
                        {{ (netAndVat$ | async)?.netAmount | currency: 'GBP' }}
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-xs-6 col-md-3 col-lg-3">
                        VAT
                    </div>
                    <div class="col-xs-6 col-md-8 col-lg-8">
                        {{ (netAndVat$ | async)?.vatAmount | currency: 'GBP' }}
                    </div>
                </div>
        </div>
    </div>
</form>